import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div
      className="Perks p-100 mobile_app_perks"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Why Choose TekRevol as Your Trusted{" "}
              <span>Mobile App Development</span> Company?
            </h2>
            <p>
              TekRevol stands as your strategic partner, not just a service
              provider. We don’t just build apps; we create powerful, scalable
              digital solutions that drive business growth, streamline
              operations, and elevate user experiences. Our mobile app
              development agency is rooted in deep technical expertise,
              industry-specific knowledge, and a relentless focus on results
              that align with your business objectives.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>
                  Top-Tier
                  <br /> Development
                </h4>
                <p>
                  Our development team excels in cutting-edge technologies like
                  Kotlin, Swift, Flutter, and React Native to build robust,
                  scalable, and secure mobile applications. We translate complex
                  business requirements into seamless, high-performance apps
                  that meet rigorous security standards and drive user
                  satisfaction.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Agile, High-Efficiency
                  <br /> Delivery
                </h4>
                <p>
                  We implement customized agile workflows that align with your
                  project’s unique needs. This approach accelerates development
                  cycles, reduces time-to-market, and ensures adaptability to
                  changing requirements, all while maintaining top quality and
                  minimizing risks.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>Comprehensive Lifecycle Management</h4>
                <p>
                  We handle every aspect of your app’s development—from initial
                  ideation through deployment and ongoing maintenance. Our
                  end-to-end services ensure your app is secure, scalable, and
                  optimized for future growth, long-term value, and reliability.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>Advanced, User-Centric Design</h4>
                <p>
                  Our UI/UX design process integrates cutting-edge design
                  principles with a deep understanding of user behavior. Our app
                  development company focuses on creating visually stunning,
                  intuitive interfaces that enhance user engagement and
                  retention.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
